<script>
import { BAlert } from 'bootstrap-vue'
import { IconCircleCheck, IconCircleXmark, IconCircleInfo, IconXmark } from '@/components/icons/index'

export default {
  name: "AppAlert",

  components: {
    BAlert,
    IconCircleCheck,
    IconCircleXmark,
    IconCircleInfo,
    IconXmark,
  },

  props: {
    containerClass: { type: String, default: '' },
    alertClass: { type: String, default: '' }
  },
  
  computed: {
    alerts() {
      return this.$store.getters['alert/alerts']
    },
    autoClose() {
      return this.$store.getters['alert/autoClose']
    },
  },

  methods: {
    isMultiple(message) {
      return Array.isArray(message);
    },
  }
}
</script>

<template>
  <div
    :class="containerClass"
    class="row align-items-center justify-content-center ms-0"
    :style="{ zIndex: '999999 !important' }"
  >
    <div class="col-md-8 col-lg-6 col-xl-5">
      <b-alert
        v-for="(alert,key) in alerts"
        :key="key"
        show
        :variant="alert.type"
        :class="alertClass"
      >
        <div class="d-flex" :class="{ 'align-items-center': !isMultiple(alert.message) }">
          <div v-if="isMultiple(alert.message)">
            <ul class="mb-0">
              <li v-for="(message, key) in alert.message" :key="key">
                {{ message }}
              </li>
            </ul>
          </div>
          <div v-else class="d-flex align-items-start">
            <div>
              <IconCircleCheck v-if="alert.type === 'success'"/>
              <IconCircleXmark v-else-if="alert.type === 'danger'"/>
              <IconCircleInfo v-else-if="alert.type === 'info'"/>
            </div>
            <div>
              <span class="ms-3 d-block">{{ alert.message }}</span>
            </div>
          </div>
          <span
            role="button"
            class="d-block ms-auto"
            @click="$store.commit('alert/clear', key)"
          > 
            <IconXmark size="12px" ></IconXmark>
          </span>

        </div>
      </b-alert>
    </div>
  </div>
</template>

<style lang="scss">
.alert-success {
  background-color: #e7f7d2;
  border-color: 1px solid #23d440 !important;
  color: #23d440;

  .close {
    color: #23d440;
  }
  path {
    stroke: #23d440;
    fill: #23d440;
  }
}

.alert-danger {
  background-color: #fbeeef;
  border-color: 1px solid #fb1f1f !important;
  color: #fb1f1f;

  .close {
    color: #fb1f1f ;
  }
  path {
    stroke: #fb1f1f;
    fill: #fb1f1f;
  }
}

.alert-info {
  background-color: #CDE8F5;
  border-color: 1px solid #4480AE !important;
  color: #4480AE;

  .close {
    color: #4480AE ;
  }
  path {
    stroke: #4480AE;
    fill: #4480AE;
  }
}

.alert .close {
  opacity: 1;
}
</style>